import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/residential-storage.jpg'),
    alt: 'residential storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'residential storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Residential <span>Storage Services</span><span>Secure & Hassle-Free Storage</span>',
  description:
    'Need extra space? Our secure and affordable residential storage options are perfect for homeowners, renters, students, and travelers. ',
  image: {
    url: '/images/v2/pages/main-pages/residential-storage/hero-image.jpg',
    alt: 'Residential Storage Services Secure & Hassle-Free Storage'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started Today' }
}

export const whyWeSectionContent = {
  title: 'How Our Residential Storage Works',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Your Storage Now' },

  cards: [
    {
      id: 1,
      title: 'Book Online',
      description: 'Schedule your residential storage service through our website or call our support team.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/book-online.png',
        alt: 'Book Online'
      }
    },
    {
      id: 2,
      title: 'Receive Your Shipping Labels',
      description: 'We send pre-labeled tags via email or mail—just attach them to your boxes.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/receive-your-shipping-labels.png',
        alt: 'Receive Your Shipping Labels'
      }
    },
    {
      id: 3,
      title: 'Drop Off or Arrange Pickup',
      description: 'Choose to drop off your items at a FedEx/DHL location or schedule a home pickup.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/drop-off-or-arrange-pickup.png',
        alt: 'Drop Off or Arrange Pickup'
      }
    },
    {
      id: 4,
      title: 'Safe & Secure Storage',
      description: 'Your things are stored in climate-controlled self storage units with advanced security features.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/safe-secure-storage.png',
        alt: 'Safe & Secure Storage'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Choose Our Residential Storage?',

  cards: [
    {
      id: 1,
      title: 'Affordable Plans',
      description:
        'Find cost-effective storage solutions that fit your budget for both short-term and long-term storage needs.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/affordable-plans.png',
        alt: 'Affordable Plans'
      }
    },
    {
      id: 2,
      title: 'Convenient Pickup & Delivery',
      description:
        'Enjoy stress-free pickup and delivery services right to your door, making storage access simple and hassle-free.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/convenient-pickup-delivery.png',
        alt: 'Convenient Pickup & Delivery'
      }
    },
    {
      id: 3,
      title: 'Secure Facilities',
      description:
        'Our storage locations feature 24/7 monitoring, advanced security, and restricted access for maximum protection.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 4,
      title: 'Global Access',
      description:
        'Easily retrieve, ship, or manage your stored belongings anytime, from anywhere in the world without hassle.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/global-access.png',
        alt: 'Global Access'
      }
    },
    {
      id: 5,
      title: 'Free Storage for Six Months',
      description:
        'Store your items securely for up to six months at no cost, with flexible and affordable long-term extension plans.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/free-storage-for-six-months.png',
        alt: 'Free Storage for Six Months'
      }
    },
    {
      id: 6,
      title: 'Professional Support',
      description:
        'Our expert team provides reliable assistance and guidance to ensure a smooth, stress-free storage experience.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/professional-support.png',
        alt: 'Professional Support'
      }
    }
  ]
}

export const benefitSectionContent = {
  title: 'Who Can Benefit from Residential Storage?',

  cards: [
    {
      id: 1,
      title: 'Homeowners & Renters',
      description:
        'Store extra furniture, seasonal decor, or household essentials with ease. Our residential storage solutions provide safe and flexible storage without clutter.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/homeowners-renters.png',
        alt: 'Homeowners & Renters'
      }
    },
    {
      id: 2,
      title: 'Students',
      description:
        'Heading home for the break or studying abroad? Our self storage units keep your dorm essentials safe and easy to access when needed.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/students.png',
        alt: 'Students'
      }
    },
    {
      id: 3,
      title: 'Military Personnel',
      description:
        'Deployment and relocations made easy with flexible residential storage solutions. Keep your valuables secure with easy retrieval options.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/military-personnel.png',
        alt: 'Military Personnel'
      }
    },
    {
      id: 4,
      title: 'Travelers',
      description:
        'Moving temporarily or traveling long-term? Our self storage facilities near me offer safe, accessible storage for your valuables.',
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/travelers.png',
        alt: 'Travelers'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Smart Storage: Maximizing Space & Security',
  description: 'Make the most of your residential storage space with these expert tips.',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Label Clearly',
          description: 'Ensure quick and easy retrieval by labeling boxes with detailed descriptions.'
        },
        {
          id: 2,
          title: 'Pack Efficiently',
          description: 'Store frequently used items at the front for convenient access.'
        },
        {
          id: 3,
          title: 'Use Durable Packing Materials',
          description: 'Protect fragile and valuable items with sturdy boxes and bubble wrap.'
        },
        {
          id: 4,
          title: 'Digitize Important Documents',
          description: 'Scan essential paperwork for added security and easy access.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/residential-storage/smart-storage-maximizing-space-security.jpg',
        alt: 'Smart Storage: Maximizing Space & Security'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Stress-Free Storage, Anytime, Anywhere!',
  description:
    'With our secure, climate-controlled residential storage solutions, you can enjoy peace of mind knowing your belongings are safe and accessible whenever you need them. Whether for short-term convenience or long-term storage, we’ve got you covered.',
  image: {
    src: '/images/v2/pages/main-pages/residential-storage/stress-free-storage-anytime-anywhere.png',
    alt: 'Stress-Free Storage, Anytime, Anywhere!'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Explore Now' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What types of items can I store?',
      answer:
        'Store furniture, household goods, appliances, and sports equipment. Hazardous materials and perishables are not allowed.'
    },
    {
      id: 2,
      question: 'Are the storage units climate-controlled?',
      answer:
        'Yes, our self storage units are designed to protect sensitive items like electronics, antiques, and artwork.'
    },
    {
      id: 3,
      question: 'How secure are your storage facilities?',
      answer:
        'Our self storage facilities near me offer 24/7 surveillance, biometric access, and fire protection systems.'
    },
    {
      id: 4,
      question: 'Do you offer pickup and delivery services?',
      answer: 'Yes, we provide door-to-door pickup and delivery for your convenience.'
    },
    {
      id: 5,
      question: 'Is there a time limit on how long I can store my items?',
      answer: 'No, we offer flexible short-term and long-term residential storage plans.'
    }
  ]
}
